import styled from "styled-components";
import SelectCommon from "components/UI/SelectCommon";
import { AREA_SOURCE_TYPES } from "constant/panel";

type Props = {
  onChange?: any;
  value?: any;
};

const AreaSourceTypeSelect = ({ onChange, value }: Props) => {
  return (
    <SelectCommon
      options={[{ label: "", value: "" }, ...AREA_SOURCE_TYPES]}
      label="type"
      value={value}
      onChange={onChange}
    />
  );
};

const DivNav = styled.div`
  margin-top: 0.75rem;
  svg {
    margin-left: 1rem;
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
  &&& > svg:first-of-type {
    margin-left: 0;
  }
`;

export default AreaSourceTypeSelect;
